module.exports = __webpack_public_path__ + "static/media/Board_After.99728dcd.jpg";